var map = {
	"./asset.json": "./src/i18n/en-us/asset.json",
	"./default.json": "./src/i18n/en-us/default.json",
	"./discovery.json": "./src/i18n/en-us/discovery.json",
	"./login.json": "./src/i18n/en-us/login.json",
	"./menu.json": "./src/i18n/en-us/menu.json",
	"./option.json": "./src/i18n/en-us/option.json",
	"./quotation.json": "./src/i18n/en-us/quotation.json",
	"./quote.json": "./src/i18n/en-us/quote.json",
	"./settings.json": "./src/i18n/en-us/settings.json",
	"./trade.json": "./src/i18n/en-us/trade.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/i18n/en-us sync \\.json$";